export default __webpack_public_path__ + "static/media/guppie.1561272e.PNG";